import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import AllRoutes from "./AllRoutes";
import Head from "./privateHeader";
import Attendance from "../Pages/User/attendance";
import { useLocation, useNavigate } from "react-router";

function CheckedLoggedIn() {
  const navigate = useNavigate();
  const loginState = useSelector((state) => state.login);
  const [approveToAttend, setApproved] = useState(false);
  const location = useLocation();
  const endpoint = location.pathname;

  useEffect(() => {
    localStorage.clear();
    const sessionKeysToPreserve = [
      "userPersistantSession",
      "deviceId",
      "webinarUserId",
      "isWebinarPageRefresh",
      "webinarId",
    ];
    Object.keys(sessionStorage).forEach((key) => {
      if (!sessionKeysToPreserve.includes(key)) {
        sessionStorage.removeItem(key);
      }
    });

    // sessionStorage.clear();
    const cookies = Cookies.get();
    for (const cookie in cookies) {
      if (
        cookie !== "popUp" &&
        cookie !== "googtrans" &&
        cookie !== "resetpassmodal" &&
        cookie !== "user" &&
        cookie !== "userlog" &&
        cookie !== "tablerTheme"
      ) {
        Cookies.remove(cookie);
      }
    }
  }, [loginState]);

  useEffect(() => {
    if (
      loginState.isLoggedIn &&
      loginState.user &&
      !(loginState.userlog && loginState.userlog.firstLogin) &&
      (loginState.user.Role === process.env.REACT_APP_ROLE_PURCHASE ||
        loginState.user.Role === process.env.REACT_APP_ROLE_ADMIN ||
        loginState.user.Role === process.env.REACT_APP_ROLE_SALLE ||
        loginState.user.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
        loginState.user.Role === process.env.REACT_APP_ROLE_AGRONOMIST ||
        loginState.user.Role === process.env.REACT_APP_ROLE_OPS ||
        loginState.user.Role === process.env.REACT_APP_ROLE_INSPECTION ||
        loginState.user.Role === process.env.REACT_APP_ROLE_MARKETING ||
        loginState.user.Role === process.env.REACT_APP_ROLE_IT ||
        loginState.user.Role === process.env.REACT_APP_ROLE_SSM ||
        loginState.user.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
        loginState.user.Role === process.env.REACT_APP_ROLE_CLIENT_FEEDBACK ||
        loginState.user.Role === process.env.REACT_APP_ROLE_HR ||
        loginState.user.Role === process.env.REACT_APP_ROLE_JR_HR ||
        loginState.user.Role === process.env.REACT_APP_ROLE_SALESCOORDINATOR)
    ) {
      navigate("/attendance");
    }
  }, [loginState]);
  if (
    approveToAttend &&
    loginState.isLoggedIn &&
    loginState.user &&
    !(loginState.userlog && loginState.userlog.firstLogin) &&
    (loginState.user.Role === process.env.REACT_APP_ROLE_PURCHASE ||
      loginState.user.Role === process.env.REACT_APP_ROLE_ADMIN ||
      loginState.user.Role === process.env.REACT_APP_ROLE_SALLE ||
      loginState.user.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
      loginState.user.Role === process.env.REACT_APP_ROLE_AGRONOMIST ||
      loginState.user.Role === process.env.REACT_APP_ROLE_OPS ||
      loginState.user.Role === process.env.REACT_APP_ROLE_INSPECTION ||
      loginState.user.Role === process.env.REACT_APP_ROLE_MARKETING ||
      loginState.user.Role === process.env.REACT_APP_ROLE_IT ||
      loginState.user.Role === process.env.REACT_APP_ROLE_SSM ||
      loginState.user.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
      loginState.user.Role === process.env.REACT_APP_ROLE_CLIENT_FEEDBACK ||
      loginState.user.Role === process.env.REACT_APP_ROLE_HR ||
      loginState.user.Role === process.env.REACT_APP_ROLE_JR_HR ||
      loginState.user.Role === process.env.REACT_APP_ROLE_SALESCOORDINATOR)
  ) {
    return <Attendance />;
  }
  return (
    <>
      {loginState?.isLoggedIn &&
        loginState?.user?.Role !== process.env.REACT_APP_ROLE_INTERNAL && (
          <Head />
        )}
      {!loginState?.isLoggedIn && !endpoint.includes("/webinar-live") && (
        <>
          <header className="navbar navbar-expand-lg sticky-top">
            <div className="container-xl">
              <h1 className="navbar-brand  d-none-navbar-horizontal pe-0 pe-md-3">
                <span className="cursor-pointer" onClick={() => navigate("/")}>
                  <h1 className="fs-large m-0 p-0">
                    <span className="text-primary">α</span>lpha
                  </h1>
                  <p className="fs-5 ps-6 m-0 text-success">by KRYZEN</p>
                </span>
              </h1>
              <div className="navbar-nav flex-row order-md-last p-1 ">
                <div className="d-none d-lg-block d-md-block mt-2">
                  {/* <span
                  className="ms-3 me-3  mt-5 "
                  style={{ fontSize: "16px", fontWeight: "500" }}
                >
                  <a
                    href="/pricing"
                    className="text-decoration-none text-black"
                  >
                    Pricing
                  </a>
                </span> */}
                  <span
                    className="ms-3 me-3 no-decoration"
                    style={{ fontSize: "16px", fontWeight: "500" }}
                  >
                    <a
                      href="/hydroponic-webinar"
                      className="text-decoration-none fs-3 text-primary cursor-pointer"
                    >
                      WEBINAR
                    </a>
                  </span>
                  <span
                    className="ms-3 me-3 no-decoration"
                    style={{ fontSize: "16px", fontWeight: "500" }}
                  >
                    <a
                      href="/agri-subsidy"
                      className="text-decoration-none fs-3 text-primary cursor-pointer"
                    >
                      SUBSIDIES
                    </a>
                  </span>
                  <span
                    className="ms-3 me-3  no-decoration"
                    style={{ fontSize: "16px", fontWeight: "500" }}
                  >
                    <a
                      href="/client-enquiry"
                      className="text-decoration-none fs-3 text-primary cursor-pointer"
                    >
                      ENQUIRY
                    </a>
                  </span>
                </div>

                <a className="btn px-4 fs-3" href="/account-login">
                  Login To Portal
                </a>
              </div>
              <div className="d-block d-lg-none d-md-none text w-100 d-flex justify-content-between border-top p-1">
                <span
                  className="ms-3 me-3"
                  style={{ fontSize: "17px", fontWeight: "500" }}
                >
                  <a
                    href="/hydroponic-webinar"
                    className="text-decoration-none fs-3 text-primary cursor-pointer"
                  >
                    WEBINAR
                  </a>
                </span>
                <span
                  className="ms-3 me-3"
                  style={{ fontSize: "17px", fontWeight: "500" }}
                >
                  <a
                    href="/agri-subsidy"
                    className="text-decoration-none fs-3 text-primary cursor-pointer"
                  >
                    SUBSIDIES
                  </a>
                </span>
                <span
                  className="ms-3 me-3"
                  style={{ fontSize: "17px", fontWeight: "500" }}
                >
                  <a
                    href="/client-enquiry"
                    className="text-decoration-none fs-3 text-primary cursor-pointer"
                  >
                    ENQUIRY
                  </a>
                </span>
              </div>
            </div>
          </header>
          {/* <NavBarNew></NavBarNew> */}
        </>
      )}
      <AllRoutes />
    </>
  );
}

export default CheckedLoggedIn;
